// questionnaire.js

import {
  RESET_QUESTIONNAIRE, LOAD_PATIENT_HOME_Q, LOAD_PATIENT_HOME_Q_RESPONSE, QUESTIONNAIRE_RESPONSE,
  PARSE_RESPONSE, DTT_PARSE_RESPONSE, FETCHING_RESPONSE, FETCHING_EMPTY_Q,
  SET_ERROR, RESET_ERROR, ON_QUESTIONNAIRE_LOADED
} from '../reducers/questionnaire';
import { questionnaireNames, msalConfig, tokenRequest, questionnaireUrl, questionnaireResponseUrl } from '../config-client';
import { callApiWithB2CToken } from '../actions/callApi';

const Msal = require('msal');

const myMSALObj = new Msal.UserAgentApplication(msalConfig);

// this is to get the Questionnaire resource (see HL7 FHIR Questionnaire resource) ONLY FOR THE PATIENTHOME PAGE
// it is the empty form (or the skeleton to the form)
export const getDTTQnaire = () => {
  // the questionnaire name changes depending on whether this is the patient app or clinician app
  // questionnaireNames.Patient would be used for the patient version app ...
  // so the query parameter requires the name of the questionnaire
  // if you want to POST a new questionnaire resource, please use a unique name as we are using it as the unique id ...
  // to filter out the correct questionnaire resource
  const url = questionnaireUrl + `?name=${questionnaireNames.Practitioner}`;
  return (dispatch) => {
    dispatch({ type: FETCHING_EMPTY_Q });
    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    return myMSALObj.acquireTokenSilent(tokenRequest)
      .then(tokenResponse => callApiWithB2CToken(url, tokenResponse.accessToken, headers, 'GET')
        .then((response) => {
          // if the response is an error then send an error message as the payload
          if (response.status !== 200 && response.status !== 201) {
            dispatch({ type: SET_ERROR, payload: '' });
          } else {
            dispatch({ type: SET_ERROR, payload: 'no error' });
          }
          return response.json();
        }))
      .then(json => dispatch({ type: LOAD_PATIENT_HOME_Q, payload: json }))
      .catch(error => dispatch({ type: LOAD_PATIENT_HOME_Q, payload: error }));
  };
};

// submit the edited or new questionnaire response resource
// this send the news response to /QuestionnaireResponse as a POST/PUT request
// the endpoint will determine whether this is actually a POST or PUT request by checking whether it has an id key in the resource object
export const submitResponse = (responseObject) => {
  const url = questionnaireResponseUrl;
  return (dispatch) => {
    dispatch({ type: QUESTIONNAIRE_RESPONSE });
    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    const body = JSON.stringify(responseObject);
    return myMSALObj.acquireTokenSilent(tokenRequest)
      .then(tokenResponse => callApiWithB2CToken(url, tokenResponse.accessToken, headers, 'POST', body)
        .then((response) => {
          // if the response is an error then send an error message as the payload
          if (response.status !== 200 && response.status !== 201) {
            dispatch({ type: SET_ERROR, payload: '' });
          } else {
            dispatch({ type: SET_ERROR, payload: 'no error' });
          }
          return response.json();
        }))
      .then((json) => {
        dispatch({ type: QUESTIONNAIRE_RESPONSE, payload: json });
      })
      .catch(error => dispatch({ type: QUESTIONNAIRE_RESPONSE, payload: error }));
  };
};

// this is to get an existing response, if it exists, ONLY FOR THE PATIENTHOME PAGE
// if the patient hasn't submitted a response ever then this should set the response object in the patient redux to null
export const getDTTResponse = (source, qid, qname) => {
  // please pass the source (the patient id) and the qname (the name of the questionnaire) as query params
  const url = questionnaireResponseUrl + `?source=${source}&qid=${qid}&qname=${qname}&patient=false`;
  return (dispatch) => {
    dispatch({ type: FETCHING_RESPONSE });
    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    return myMSALObj.acquireTokenSilent(tokenRequest)
      .then(tokenResponse => callApiWithB2CToken(url, tokenResponse.accessToken, headers, 'GET')
        .then((response) => {
          // if the response is an error then send an error message as the payload
          if (response.status !== 200 && response.status !== 201) {
            dispatch({ type: SET_ERROR, payload: '' });
          } else {
            dispatch({ type: SET_ERROR, payload: 'no error' });
          }
          return response.json();
        }))
      .then(json => dispatch({ type: LOAD_PATIENT_HOME_Q_RESPONSE, payload: json.resource }))
      .catch(error => dispatch({ type: LOAD_PATIENT_HOME_Q_RESPONSE, payload: error }));
  };
};


// reset the questionnaire reducer altogether
export const resetQnaire = () => (dispatch) => {
  dispatch({
    type: RESET_QUESTIONNAIRE,
    payload: null,
  });
};

// load the form object of the questionnaire response to repopulate the form fields
export const load = responseObject => (dispatch) => {
  dispatch({
    type: DTT_PARSE_RESPONSE,
    payload: responseObject,
  });
};

// reset the error message once the page is reloaded
export const resetQnaireError = () => (dispatch) => {
  dispatch({
    type: RESET_ERROR,
    payload: null,
  });
};

// ================================= NEW QUESTIONNAIRE FUNCTIONS SEP 2020 ======================================

// this is to get the Questionnaire resource by its name (DTT/Recommendation)
export const getQuestionnaireByName = (name) => {
  // the query parameter requires the name of the questionnaire
  // if you want to POST a new questionnaire resource, please use a unique name as we are using it as the unique id ...
  // to filter out the correct questionnaire resource
  const url = questionnaireUrl + `?name=${name}`;
  return (dispatch) => {
    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    return myMSALObj.acquireTokenSilent(tokenRequest)
      .then(tokenResponse => callApiWithB2CToken(url, tokenResponse.accessToken, headers, 'GET')
        .then((response) => {
          return response.json();
        })
      )
      .then(json => dispatch({ type: ON_QUESTIONNAIRE_LOADED, payload: json }))
      .catch(error => dispatch({ type: ON_QUESTIONNAIRE_LOADED, payload: error }));
  }
};

// Skeleton function for fetching appropriate QuestionnnaireResponse Object
export const getQuestionnaireResponseByReference = (source, qid, qname) => {
  const url = questionnaireResponseUrl + `?source=${source}&qid=${qid}&qname=${qname}&patient=false`;
  return (dispatch) => {
    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    return myMSALObj.acquireTokenSilent(tokenRequest)
      .then(tokenResponse => callApiWithB2CToken(url, tokenResponse.accessToken, headers, 'GET')
        .then((response) => {
          return response.json();
        })
      )
      .then(json => dispatch({ type: QUESTIONNAIRE_RESPONSE, payload: json.resource }))
      .catch(error => dispatch({ type: QUESTIONNAIRE_RESPONSE, payload: error }));
  }
};

// load the form object of the questionnaire response to repopulate the form fields
export const loadQnaire = responseObject => (dispatch) => {
  dispatch({
    type: PARSE_RESPONSE,
    payload: responseObject,
  });
};



// WEBPACK FOOTER //
// ./src/actions/questionnaire.js